var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "scroll",
      class: [_vm.$.standart_columns_list, "gantt_scroll"],
      style: { height: _vm.height },
    },
    _vm._l(_vm.columns, function (cols, groupName) {
      return _c(
        "div",
        { key: groupName, class: _vm.$.standart_columns_list__group },
        [
          _c("div", { class: _vm.$.title }, [
            _c("div", [
              _vm._v(
                "\n        " +
                  _vm._s(_vm.locales("standart_columns_group_" + groupName)) +
                  "\n      "
              ),
            ]),
            _vm._v(" "),
            _c("span", { class: _vm.$.line }),
          ]),
          _vm._v(" "),
          _vm._l(cols, function (item, index) {
            return _c("div", { key: index, class: _vm.$.item }, [
              _c(
                "div",
                { class: _vm.$.standart_column_row },
                [
                  _c("tooltip", {
                    class: _vm.$.tooltip_wrapper,
                    attrs: {
                      content: item.tooltip,
                      position: "left",
                      interactive: true,
                      "with-animation": false,
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "body",
                          fn: function () {
                            return [
                              _c("svg-sprite", { attrs: { name: item.icon } }),
                              _vm._v(" "),
                              _c("div", { class: _vm.$.name }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item.value) +
                                    "\n            "
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm._v(" "),
                  _c("div", { class: _vm.$.right_side }, [
                    item.id === "total_price"
                      ? _c(
                          "div",
                          { class: _vm.$.edit },
                          [
                            _c("vgp-button", {
                              attrs: {
                                label: _vm.locales("currency_column_edit"),
                                type: "text-grey",
                                icon: { name: "pensil", size: 16 },
                                "icon-side": "right",
                                small: true,
                              },
                              on: { onClick: _vm.openBudgetEditor },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { class: _vm.$.checkbox },
                      [
                        _c("vgp-checkbox", {
                          attrs: { size: 16, checked: item.enabled },
                          on: {
                            onChange: function ($event) {
                              return _vm.onChange($event, item)
                            },
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
              _vm._v(" "),
              item.option
                ? _c(
                    "div",
                    {
                      class: [
                        _vm.$.standart_column_row,
                        _vm.$.advanced_option,
                        !item.enabled ? _vm.$.advanced_option__disable : "",
                      ],
                    },
                    [
                      _c("svg-sprite", { attrs: { name: item.optionIcon } }),
                      _vm._v(" "),
                      _c("div", { class: _vm.$.name }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(item.optionValue) +
                            "\n        "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { class: _vm.$.checkbox },
                        [
                          _c("vgp-checkbox", {
                            attrs: {
                              size: 16,
                              "is-disable": !item.enabled,
                              checked: item.enabledOption,
                            },
                            on: {
                              onChange: function ($event) {
                                return _vm.onChangeOption($event, item)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ])
          }),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }